<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    Reports
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="accent" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'Report')"><v-icon small class="mr-2">fa-plus</v-icon> Add Record</v-btn>
                    <v-btn class="accent" @click="smsDialog=true"><v-icon small class="mr-2">fa-phone</v-icon> Test Message</v-btn>
                    <report-config-dialog v-model="dialog" :item="editedItem"></report-config-dialog>
                    <sms-dialog v-model="smsDialog"></sms-dialog>
                </v-card-actions>

                <v-card-text>
                    <v-data-table
                    :headers="headers"
                    :items="rules"
                    class="elevation-1"
                    >
      <template v-slot:items="props">
        <td>{{ props.item.title }}</td>
        <td class="text-xs-left">{{ props.item.severity_levels }}</td>
        <td class="text-xs-left">{{ props.item.topic }}</td>
        <td class="text-xs-left">{{ props.item.email_frequency }}</td>
        <td class="text-xs-left">{{ props.item.emails }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            fa-edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            fa-trash
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Refresh</v-btn>
      </template>
    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getReportConfig, deleteReportConfig} from '../helper'
import ReportConfigDialog from '../components/recordconfig/ReportConfigDialog'
import SmsDialog from "../components/recordconfig/SmsDialog";

export default {
    name: 'ReportConfig',
  components: { ReportConfigDialog,SmsDialog  },
  data: () => ({
      dialog: false,
      smsDialog: false,
      headers: [
        {
          text: 'Title ',
          align: 'left',
          sortable: true,
          value: 'title'
        },
        { text: 'Severity Level(s) ', value: 'severity_levels' },
        { text: 'Topic ', value: 'topic' },
        { text: 'Frequency ', value: 'email_frequency' },
        { text: 'Distribution List ', value: 'emails', sortable: false },
      ],
      rules: [
      ],
      editedIndex: -1,
      editedItem: {
      },
    }),
  watch: {
      dialog () {
        this.refresh()
      }
  },
  mounted() {
    this.initialize()
  },
    methods: {
      initialize () {
        this.refresh()
      },

      editItem (item) {
        this.editedIndex = this.rules.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      async deleteItem (item) {
        const index = this.rules.indexOf(item)
        if (confirm('Are you sure you want to delete this item?') ){
          this.rules.splice(index, 1)
          await deleteReportConfig({
            'reportconfig_id': item.reportconfig_id
          })
          this.refresh()
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.rules[this.editedIndex], this.editedItem)
        } else {
          this.rules.push(this.editedItem)
        }
        this.close()
      },
      async refresh() {
        let df = await getReportConfig({
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
        })
        this.rules = df['result']
      }
    }
  }
</script>

<style scoped>

</style>
